import { MutableRefObject, useEffect, useRef } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { clearSsoHint, hasSsoHint, setSsoHint } from './SessionTransfer.utils';

export const useSsoSessionPickup = (): MutableRefObject<boolean> => {
  const { isLoading, isAuthenticated, getAccessTokenSilently } = useAuth0();
  const didFetchFreshSession = useRef(false);
  const hasProbed = useRef(false);

  useEffect(() => {
    if (isLoading) return;

    if (isAuthenticated) {
      hasProbed.current = true;
      setSsoHint();
      return;
    }

    if (hasProbed.current || !hasSsoHint()) return;
    hasProbed.current = true;
    didFetchFreshSession.current = true;

    getAccessTokenSilently().catch(() => {
      clearSsoHint();
    });
  }, [isLoading, isAuthenticated, getAccessTokenSilently]);

  return didFetchFreshSession;
};
